/* ============================================================
   SAFF DOĞAL TAŞ — Doğum Haritası yorum içeriği
   Yapı: her burç için üç bağlam (Güneş / Ay / Yükselen) + tek bir "ton"
   sıfatı. Gezegen yorumları "gezegenin işlevi + burcun tonu" biçiminde
   birleştirilir; böylece 7×12 = 84 ayrı metin yazmak yerine doğal
   cümleler üretilir ve dil tutarlı kalır.
   ============================================================ */
(function (g) {
  'use strict';

  /* ---------------------------------------------------------- BURÇLAR */
  var BURC = [
    {
      ad: 'Koç', sembol: '♈', element: 'Ateş', nitelik: 'Öncü', yonetici: 'Mars',
      koleksiyon: 'koc',
      ton: 'doğrudan, cesur ve hızlı',
      oz: 'Başlamak senin doğan. Bir fikir aklına düştüğü an harekete geçersin; ' +
          'beklemek, senin için düşünmekten daha yorucudur. Cesaretin çevrendekilere de ateş verir.',
      duygu: 'Duyguların ani ve saftır — öfken de sevgin de anında görünür. Uzun süre küs kalamazsın; ' +
             'içinde biriktirmek yerine boşaltıp yoluna devam edersin.',
      maske: 'İnsanlar seni enerjik, atılgan ve biraz aceleci bulur. İlk izlenimin güçlüdür; ' +
             'odaya girdiğinde fark edilirsin.',
      taslar: 'Granat · Kırmızı Akik · Hematit · Ametist',
      dengeNotu: 'Ateşini söndürmeyen ama yönlendiren taşlar sana iyi gelir.'
    },
    {
      ad: 'Boğa', sembol: '♉', element: 'Toprak', nitelik: 'Sabit', yonetici: 'Venüs',
      koleksiyon: 'boga',
      ton: 'sabırlı, sağlam ve zevkli',
      oz: 'Kalıcı olanı kurarsın. Aceleye gelmez, sağlamı seversin; bir şeye değer verdiysen ' +
          'kolay kolay vazgeçmezsin. Güzellik senin için lüks değil, ihtiyaçtır.',
      duygu: 'Duygusal olarak yavaş ısınır, ısındığında derin bağlanırsın. Güven duygusu ' +
             'senin için sevginin ta kendisidir; sarsıldığında en çok o incinir.',
      maske: 'Sakin, güven veren ve dingin görünürsün. İnsanlar yanında rahatlar — ' +
             'telaşın yokluğu bulaşıcıdır.',
      taslar: 'Pembe Kuvars · Yeşim · Malakit · Akik',
      dengeNotu: 'Seni yumuşatan, değişime açan taşlar dengeni tamamlar.'
    },
    {
      ad: 'İkizler', sembol: '♊', element: 'Hava', nitelik: 'Değişken', yonetici: 'Merkür',
      koleksiyon: 'ikizler',
      ton: 'meraklı, çevik ve iletişimci',
      oz: 'Öğrenmek ve aktarmak için gelmişsin. Zihnin aynı anda birkaç yerde olabilir; ' +
          'bu dağınıklık değil, senin doğal işleyişin. Kelimeler senin elinde araç olur.',
      duygu: 'Duygularını anlamak için önce anlatman gerekir. Konuşmadığında içeride ' +
             'düğümlenir; bir dosta anlattığın anda çözülürsün.',
      maske: 'Sohbeti açan, ortamı canlandıran kişi sensin. Zeki ve esprili görünürsün; ' +
             'insanlar seninle konuşmayı kolay bulur.',
      taslar: 'Akik · Sitrin · Kaplan Gözü · Akuamarin',
      dengeNotu: 'Odaklayan ve yere indiren taşlar seni tamamlar.'
    },
    {
      ad: 'Yengeç', sembol: '♋', element: 'Su', nitelik: 'Öncü', yonetici: 'Ay',
      koleksiyon: 'yengec',
      ton: 'sezgisel, koruyucu ve derin',
      oz: 'Bağ kurmak ve korumak senin işin. Sevdiklerin için kabuğunu bile riske atarsın. ' +
          'Hafızan güçlüdür — yaşadıklarını kolay unutmazsın, bu hem zenginliğin hem yükün.',
      duygu: 'Duygusal olarak son derece geçirgensin; odadaki havayı kimse söylemeden anlarsın. ' +
             'Kendini güvende hissetmediğinde içine çekilir, orada iyileşirsin.',
      maske: 'Sıcak, ilgili ve biraz çekingen görünürsün. İnsanlar sana içini açar — ' +
             'güvenilir bir liman olduğun hissedilir.',
      taslar: 'Ay Taşı · Pembe Kuvars · Selenit · Akuamarin',
      dengeNotu: 'Duygusal dalgayı sakinleştiren ay taşları senin taşındır.'
    },
    {
      ad: 'Aslan', sembol: '♌', element: 'Ateş', nitelik: 'Sabit', yonetici: 'Güneş',
      koleksiyon: 'aslan',
      ton: 'cömert, sıcak ve görkemli',
      oz: 'Işığını saklamak sana ağır gelir. Yaratmak, sahne almak ve tanınmak senin için ' +
          'gösteriş değil, var oluş biçimidir. Cömertliğin gerçek ve karşılıksızdır.',
      duygu: 'Kalbin büyüktür ve kolay kırılır. Görülmediğinde küser ama uzun tutmazsın; ' +
             'küçük bir takdir seni bir anda ısıtır.',
      maske: 'Kendine güvenen, sıcak ve etkileyici görünürsün. Girdiğin ortamın ' +
             'sıcaklığını yükseltirsin.',
      taslar: 'Sitrin · Kaplan Gözü · Güneş Taşı · Kehribar',
      dengeNotu: 'Güneşin taşları seni büyütür; alçakgönüllülük taşları dengeler.'
    },
    {
      ad: 'Başak', sembol: '♍', element: 'Toprak', nitelik: 'Değişken', yonetici: 'Merkür',
      koleksiyon: 'basak',
      ton: 'titiz, çözümleyici ve hizmetkâr',
      oz: 'Detayı görürsün ve düzeltmek istersin. Yardım etmek senin sevgi dilindir; ' +
          'çoğu zaman kimse istemeden yaparsın. İşini iyi yapmak seni huzurlu kılar.',
      duygu: 'Duygularını önce analiz eder, sonra hissetmeye izin verirsin. İçindeki eleştirmen ' +
             'yüksek sesle konuşur — en sert olduğun kişi kendinsin.',
      maske: 'Düzenli, ölçülü ve güvenilir görünürsün. İnsanlar sana iş verirken içleri rahat eder.',
      taslar: 'Yeşim · Amazonit · Sitrin · Kırmızı Akik',
      dengeNotu: 'İç sesini yumuşatan yeşil taşlar sana en çok iyi gelen gruptur.'
    },
    {
      ad: 'Terazi', sembol: '♎', element: 'Hava', nitelik: 'Öncü', yonetici: 'Venüs',
      koleksiyon: 'terazi',
      ton: 'uyumlu, adil ve zarif',
      oz: 'Dengeyi ararsın — ilişkilerde, mekânda, sözde. Karşındakinin hakkını görmek ' +
          'senin için doğal bir refleks. Güzellik ve adalet aynı yerden beslenir sende.',
      duygu: 'Çatışmadan rahatsız olursun; huzuru korumak için kendi ihtiyacını erteleyebilirsin. ' +
             'Yalnız kaldığında değil, uyum bozulduğunda üşürsün.',
      maske: 'Zarif, nazik ve hoş görünürsün. İnsanlar seninle olmayı kolay ve keyifli bulur.',
      taslar: 'Lapis Lazuli · Pembe Kuvars · Ametist · Opal',
      dengeNotu: 'Kararlılık veren taşlar terazinin eksik kefesidir.'
    },
    {
      ad: 'Akrep', sembol: '♏', element: 'Su', nitelik: 'Sabit', yonetici: 'Plüton · Mars',
      koleksiyon: 'akrep',
      ton: 'derin, tutkulu ve dönüştürücü',
      oz: 'Yüzeyde kalmayı beceremezsin. Bir şeyin özünü görmek, gerçeğini bilmek istersin. ' +
          'Yıkılıp yeniden kurulmak senin için felaket değil, doğal bir döngü.',
      duygu: 'Duyguların yoğun ve mahremdir; herkese açılmazsın. Güvendiğinde ise sonuna kadar ' +
             'gidersin. İhanet, senin için en zor onarılan şeydir.',
      maske: 'Gizemli, yoğun ve etkileyici görünürsün. İnsanlar seni tam çözemez — ' +
             'bu da ilgi çeker.',
      taslar: 'Obsidyen · Malakit · Granat · Labradorit',
      dengeNotu: 'Koruyucu siyah taşlar senin doğal zırhındır.'
    },
    {
      ad: 'Yay', sembol: '♐', element: 'Ateş', nitelik: 'Değişken', yonetici: 'Jüpiter',
      koleksiyon: 'yay',
      ton: 'özgür, arayıcı ve iyimser',
      oz: 'Ufuk çizgisi sana evden daha çekici gelir. Anlam ararsın — yolculukta, kitapta, ' +
          'inançta. Kısıtlandığında değil, anlamsızlaştığında solarsın.',
      duygu: 'İyimserliğin gerçektir ama duygusal derinlikten kaçma eğilimin olabilir. ' +
             'Ağır anlarda hemen "yoluna devam etmek" istersin.',
      maske: 'Neşeli, açık sözlü ve maceracı görünürsün. Yanında insanlar kendini özgür hisseder.',
      taslar: 'Turkuaz · Lapis Lazuli · Ametist · Sodalit',
      dengeNotu: 'Mavi taşlar arayışına yön verir; toprak taşları kök salmanı sağlar.'
    },
    {
      ad: 'Oğlak', sembol: '♑', element: 'Toprak', nitelik: 'Öncü', yonetici: 'Satürn',
      koleksiyon: 'oglak',
      ton: 'disiplinli, sabırlı ve sorumlu',
      oz: 'Uzun yolu göze alırsın. Sabrın ve disiplinin, çoğu kişinin yeteneğinden daha güçlüdür. ' +
          'Yükü sen taşırsın; kimse istemeden omzunu verirsin.',
      duygu: 'Duygularını göstermek sana zayıflık gibi gelebilir. İçeride derin hissedersin ' +
             'ama dışarı vermek zaman ister — güven ister.',
      maske: 'Ciddi, olgun ve güvenilir görünürsün. Yaşından büyük durursun, bu hep böyleydi.',
      taslar: 'Obsidyen · Siyah Turmalin · Granat · Kaplan Gözü',
      dengeNotu: 'Yükü hafifleten, dinlenmeyi hatırlatan taşlar senin için önemlidir.'
    },
    {
      ad: 'Kova', sembol: '♒', element: 'Hava', nitelik: 'Sabit', yonetici: 'Uranüs · Satürn',
      koleksiyon: 'kova',
      ton: 'özgün, vizyoner ve bağımsız',
      oz: 'Herkesin gittiği yoldan gitmemek senin doğal hâlin. İleriyi görürsün; bu yüzden ' +
          'bazen zamanından erken konuşmuş olursun. Topluluğa aidiyetin fikir üzerinden kurulur.',
      duygu: 'Duyguyu zihinle çözmeye çalışırsın. Yakınlık istersin ama boğulmaktan korkarsın; ' +
             'mesafe senin nefes alanın.',
      maske: 'Farklı, ilginç ve biraz mesafeli görünürsün. İnsanlar seni kolay unutmaz.',
      taslar: 'Ametist · Akuamarin · Labradorit · Granat',
      dengeNotu: 'Kalbe indiren taşlar, zihninle duygun arasındaki köprüyü kurar.'
    },
    {
      ad: 'Balık', sembol: '♓', element: 'Su', nitelik: 'Değişken', yonetici: 'Neptün · Jüpiter',
      koleksiyon: 'balik',
      ton: 'şefkatli, hayalperest ve geçirgen',
      oz: 'Sınırların incedir — başkasının duygusunu kendi duygun sanacak kadar geçirgensin. ' +
          'Sanat, hayal ve şefkat senin doğal dilin. Dünyayı olduğu gibi değil, olabileceği gibi görürsün.',
      duygu: 'Derin ve akışkan hissedersin. Kalabalıktan sonra yalnız kalmak sana ilaç gibidir; ' +
             'bu kaçış değil, temizlenme.',
      maske: 'Yumuşak, anlayışlı ve rüyalı görünürsün. İnsanlar yanında yargılanmadıklarını hisseder.',
      taslar: 'Akuamarin · Ametist · Ay Taşı · Florit',
      dengeNotu: 'Sınır çizen ve koruyan taşlar senin en çok ihtiyaç duyduğun gruptur.'
    }
  ];

  /* ---------------------------------------------------------- GEZEGENLER */
  var GEZEGEN = {
    gunes:   { ad: 'Güneş',   sembol: '☉', islev: 'öz benliğin, hayat enerjin ve varlık biçimin',
               kisa: 'Kim olduğun' },
    ay:      { ad: 'Ay',      sembol: '☽', islev: 'duygusal doğan, iç dünyan ve güvenlik ihtiyacın',
               kisa: 'Ne hissettiğin' },
    merkur:  { ad: 'Merkür',  sembol: '☿', islev: 'zihnin, öğrenme ve iletişim biçimin',
               kisa: 'Nasıl düşündüğün' },
    venus:   { ad: 'Venüs',   sembol: '♀', islev: 'sevme biçimin, zevklerin ve değer verdiklerin',
               kisa: 'Nasıl sevdiğin' },
    mars:    { ad: 'Mars',    sembol: '♂', islev: 'iraden, öfken ve harekete geçme tarzın',
               kisa: 'Nasıl mücadele ettiğin' },
    jupiter: { ad: 'Jüpiter', sembol: '♃', islev: 'büyüme alanın, şansın ve inanç dünyan',
               kisa: 'Nerede genişlediğin' },
    saturn:  { ad: 'Satürn',  sembol: '♄', islev: 'sınavın, disiplinin ve olgunlaştığın alan',
               kisa: 'Nerede sınandığın' }
  };

  /* ---------------------------------------------------------- EVLER */
  var EV = [
    { no: 1,  ad: 'Kimlik',        konu: 'kendini sunma biçimin, bedenin ve ilk izlenimin' },
    { no: 2,  ad: 'Değerler',      konu: 'para, mülk ve kendine biçtiğin değer' },
    { no: 3,  ad: 'İletişim',      konu: 'öğrenme, kardeşler, yakın çevre ve kısa yolculuklar' },
    { no: 4,  ad: 'Kökler',        konu: 'ev, aile, geçmiş ve içindeki güvenli liman' },
    { no: 5,  ad: 'Yaratım',       konu: 'aşk, çocuklar, oyun ve kendini ifade etme' },
    { no: 6,  ad: 'Düzen',         konu: 'iş rutini, sağlık ve gündelik hizmet' },
    { no: 7,  ad: 'Ortaklık',      konu: 'evlilik, ikili ilişkiler ve karşındaki insan' },
    { no: 8,  ad: 'Dönüşüm',       konu: 'derin bağlar, ortak kaynaklar ve yeniden doğuş' },
    { no: 9,  ad: 'Anlam',         konu: 'inanç, yüksek öğrenim, yabancı diyarlar ve felsefe' },
    { no: 10, ad: 'Kariyer',       konu: 'mesleğin, toplumdaki yerin ve hedefin' },
    { no: 11, ad: 'Topluluk',      konu: 'arkadaşlar, gruplar ve gelecek hayallerin' },
    { no: 12, ad: 'İç Dünya',      konu: 'bilinçaltı, yalnızlık, teslimiyet ve gizli güçler' }
  ];

  /* ---------------------------------------------------------- ELEMENT / NİTELİK */
  var ELEMENT = {
    'Ateş':   { baskin: 'Haritanda ateş baskın. Girişken, cesur ve hareketlisin; ilham seni ' +
                        'harekete geçirir. Dikkat: acele ve tükenme.',
                eksik:  'Haritanda ateş zayıf. Harekete geçmek için gereken kıvılcımı dışarıdan ' +
                        'beklemek yerine, küçük başlangıçlarla kendin üretmen gerekebilir.',
                tas: 'Kırmızı Akik · Sitrin · Granat' },
    'Toprak': { baskin: 'Haritanda toprak baskın. Gerçekçi, sabırlı ve üretkensin; somut olanı ' +
                        'seversin. Dikkat: katılık ve fazla temkin.',
                eksik:  'Haritanda toprak zayıf. Fikirlerini somuta indirmek, düzen kurmak ve ' +
                        'maddi tarafı yönetmek özel çaba isteyebilir.',
                tas: 'Hematit · Obsidyen · Yeşim' },
    'Hava':   { baskin: 'Haritanda hava baskın. Zihinsel, iletişimci ve nesnelsin; fikirlerle ' +
                        'yaşarsın. Dikkat: aşırı düşünme ve duygudan kaçış.',
                eksik:  'Haritanda hava zayıf. Duyguyu sözcüğe dökmek ve mesafeden bakmak ' +
                        'zaman zaman zorlanabilir.',
                tas: 'Akuamarin · Sodalit · Florit' },
    'Su':     { baskin: 'Haritanda su baskın. Sezgisel, şefkatli ve derin hissedersin; ortamı ' +
                        'okursun. Dikkat: sınır kaybı ve duygusal yorgunluk.',
                eksik:  'Haritanda su zayıf. Duyguya alan açmak, kırılganlığı göstermek ve ' +
                        'sezgiye güvenmek öğrenilmesi gereken bir dil olabilir.',
                tas: 'Ay Taşı · Ametist · Pembe Kuvars' }
  };

  var NITELIK = {
    'Öncü':     'Başlatmak senin gücün — yeni bir şey kurmak, ilk adımı atmak sana doğal gelir.',
    'Sabit':    'Sürdürmek senin gücün — başladığın işi bitirir, sadakatini korursun.',
    'Değişken': 'Uyum sağlamak senin gücün — koşul değiştiğinde bükülür ama kırılmazsın.'
  };

  /* ---------------------------------------------------------- AÇILAR */
  var ACI = [
    { ad: 'Kavuşum',  derece: 0,   tolerans: 8, tur: 'güçlü',
      metin: 'iç içe geçmiş, birbirini besleyen iki güç' },
    { ad: 'Karşıt',   derece: 180, tolerans: 8, tur: 'gerilim',
      metin: 'denge arayan, seni iki uç arasında salınmaya iten bir gerilim' },
    { ad: 'Üçgen',    derece: 120, tolerans: 7, tur: 'akış',
      metin: 'doğuştan gelen, çaba istemeyen bir kolaylık' },
    { ad: 'Kare',     derece: 90,  tolerans: 7, tur: 'gerilim',
      metin: 'seni zorlayan ama olgunlaştıran verimli bir sürtünme' },
    { ad: 'Altmışlık', derece: 60, tolerans: 5, tur: 'akış',
      metin: 'fark ettiğinde kolayca kullanabileceğin bir fırsat' }
  ];

  /* ---------------------------------------------------------- ODAK SORULARI */
  /* Harita hesabı sorulara bağlı DEĞİLDİR; bu sorular yorumun hangi
     alanlara ağırlık vereceğini ve ürün önerisinin yönünü belirler. */
  var SORULAR = [
    { k: 'alan', s: 'Şu dönemde hayatının hangi alanı en çok ilgini istiyor?',
      c: [ { m: 'İlişkiler ve aşk',        v: 'ask' },
           { m: 'Kariyer ve para',         v: 'kariyer' },
           { m: 'İç huzur ve ruhsal yön',  v: 'ruh' },
           { m: 'Sağlık ve günlük düzen',  v: 'saglik' } ] },
    { k: 'hal', s: 'Bugünlerde kendini en çok nasıl tanımlarsın?',
      c: [ { m: 'Bir eşiğin önünde, karar bekliyorum', v: 'esik' },
           { m: 'Yorgunum, toparlanmam gerek',        v: 'yorgun' },
           { m: 'Yeni bir şeye başlamak üzereyim',     v: 'baslangic' },
           { m: 'İyiyim, daha derine inmek istiyorum', v: 'derinlik' } ] },
    { k: 'guc', s: 'Kendinde en çok güvendiğin taraf hangisi?',
      c: [ { m: 'Sezgim',            v: 'sezgi' },
           { m: 'Mantığım',          v: 'mantik' },
           { m: 'Kararlılığım',      v: 'irade' },
           { m: 'Şefkatim',          v: 'kalp' } ] },
    { k: 'zorluk', s: 'Seni en çok ne yoruyor?',
      c: [ { m: 'Karar verememek',              v: 'karar' },
           { m: 'Hayır diyememek',              v: 'sinir' },
           { m: 'Aşırı düşünmek',               v: 'zihin' },
           { m: 'Duygularımı taşımak',          v: 'duygu' } ] },
    { k: 'niyet', s: 'Bu analizden ne almak istersin?',
      c: [ { m: 'Kendimi daha iyi tanımak',     v: 'tanima' },
           { m: 'Yönümü netleştirmek',          v: 'yon' },
           { m: 'Bana iyi gelecek taşı bulmak', v: 'tas' },
           { m: 'Sadece merak, keyif için',     v: 'merak' } ] }
  ];

  /* Odak cevaplarına göre öne çıkarılacak ev ve ton */
  var ODAK_EV = { ask: 7, kariyer: 10, ruh: 12, saglik: 6 };
  var ODAK_METIN = {
    ask:     'İlişkiler alanına bakmak istediğini söyledin; haritanda ortaklık evini ve Venüs’ü öne aldık.',
    kariyer: 'Kariyer ve maddi alan dedin; haritanda meslek evini ve Satürn’ü öne aldık.',
    ruh:     'İç huzur dedin; haritanda iç dünya evini ve Ay’ı öne aldık.',
    saglik:  'Sağlık ve düzen dedin; haritanda gündelik düzen evini ve Merkür’ü öne aldık.'
  };
  var HAL_METIN = {
    esik:       'Bir eşikte olduğunu söyledin — haritandaki gerilim açıları tam da bu dönemde işine yarar.',
    yorgun:     'Yorgun olduğunu söyledin; aşağıdaki taş önerilerinde toparlayıcı olanları öne çıkardık.',
    baslangic:  'Yeni bir başlangıcın eşiğindesin; haritandaki öncü niteliğe özellikle bak.',
    derinlik:   'Daha derine inmek istediğini söyledin; açılar bölümü senin için en besleyici kısım olacak.'
  };


  /* ---------------------------------------------------------- ALAN DERİN OKUMA
     Kullanıcı "hangi alan?" dedi diye tek cümleyle geçmek yetersizdi.
     Burada o alanın evi, evin burcu, evdeki gezegenler ve evin YÖNETİCİSİ
     birlikte okunur — geleneksel astrolojinin gerçek tekniği budur. */

  /* Klasik yöneticiler: Plüton/Uranüs/Neptün hesaplanmadığı için geleneksel
     eşleşme kullanılır — astrolojik olarak da tutarlıdır. */
  var YONETICI = ['mars','venus','merkur','ay','gunes','merkur',
                  'venus','mars','jupiter','saturn','saturn','jupiter'];

  var ALAN = {
    ask: {
      ad: 'İlişkiler ve aşk', ev: 7, anaGezegen: ['venus','mars'],
      giris: 'İlişkileri sordun. Astrolojide bu soru tek bir yere değil, üç yere birden bakmayı gerektirir: ' +
             'ortaklık evine, Venüs’e (nasıl sevdiğin) ve Mars’a (neyi arzuladığın).',
      evGiris: 'Yedinci ev, hayatını paylaştığın kişiyi ve ikili ilişkilerde takındığın tavrı anlatır. ' +
               'Bu evin burcu, “karşındaki kim olsun” sorusunun sessiz cevabıdır.',
      element: {
        'Ateş':   'Ateş burcunda: ilişkide canlılık, tutku ve hareket ararsın. Durgunluk seni söndürür.',
        'Toprak': 'Toprak burcunda: ilişkide güven, süreklilik ve somut adım ararsın. Sözden çok davranışa bakarsın.',
        'Hava':   'Hava burcunda: ilişkide sohbet, zihinsel uyum ve özgürlük ararsın. Boğulmaktan korkarsın.',
        'Su':     'Su burcunda: ilişkide derinlik, duygusal güven ve sezgisel bağ ararsın. Yüzeysellik seni yorar.'
      },
      bosEv: 'Yedinci evinde gezegen yok — bu kötü bir şey değil; ilişkilerin senin için “çözülmesi gereken bir ' +
             'düğüm” olmadığı, daha akışkan ilerlediği anlamına gelir.'
    },
    kariyer: {
      ad: 'Kariyer ve maddi alan', ev: 10, anaGezegen: ['saturn','mars'],
      giris: 'Kariyeri sordun. Buna üç yerden bakılır: meslek evine, Satürn’e (nerede sınandığın ve ' +
             'olgunlaştığın) ve Mars’a (nasıl mücadele ettiğin).',
      evGiris: 'Onuncu ev, mesleğini ve toplumda görünen yüzünü taşır. Bu evin burcu, kariyerine hangi ' +
               'tavırla yaklaştığını ve nasıl bir işte parladığını söyler.',
      element: {
        'Ateş':   'Ateş burcunda: öncülük, girişim ve görünürlük isteyen işlerde parlarsın. Rutin seni tüketir.',
        'Toprak': 'Toprak burcunda: somut sonuç üreten, sağlam ve sürdürülebilir işlerde parlarsın. Sabrın avantajın.',
        'Hava':   'Hava burcunda: iletişim, fikir ve insan ilişkisi gerektiren işlerde parlarsın. Tek başına kapalı iş seni sıkar.',
        'Su':     'Su burcunda: sezgi, şefkat ya da yaratıcılık isteyen işlerde parlarsın. Duygusuz bir ortam verimini düşürür.'
      },
      bosEv: 'Onuncu evinde gezegen yok — kariyerin tek bir sabit çizgiye bağlı değil demektir. Yönünü ' +
             'evin yöneticisi ve Satürn’ün konumu belirler.'
    },
    ruh: {
      ad: 'İç huzur ve ruhsal yön', ev: 12, anaGezegen: ['ay','jupiter'],
      giris: 'İç huzuru sordun. Bu soru haritanın en sessiz köşesine bakar: on ikinci eve, Ay’a ' +
             '(duygusal doğana) ve Jüpiter’e (anlam arayışına).',
      evGiris: 'On ikinci ev; yalnızlık, bilinçaltı, teslimiyet ve içeride sakladıkların. Bu evin burcu, ' +
               'kendinle baş başa kaldığında hangi hâlde olduğunu anlatır.',
      element: {
        'Ateş':   'Ateş burcunda: içine döndüğünde bile bir hareket ihtiyacı duyarsın. Yürüyüş, spor ya da yaratma senin meditasyonun.',
        'Toprak': 'Toprak burcunda: huzuru somutta bulursun — doğa, toprak, elle yapılan iş. Soyut arayışlar seni tatmin etmez.',
        'Hava':   'Hava burcunda: huzur için önce anlamak istersin. Okumak, yazmak ve konuşmak senin arınma yolun.',
        'Su':     'Su burcunda: huzuru sessizlikte ve suda bulursun. Duygusal boşalma sana ilaç gibi gelir.'
      },
      bosEv: 'On ikinci evinde gezegen yok — iç dünyan seni fazla meşgul etmiyor demektir. Huzurun ' +
             'Ay’ının durumuna bağlı ilerler.'
    },
    saglik: {
      ad: 'Sağlık ve günlük düzen', ev: 6, anaGezegen: ['merkur','ay'],
      giris: 'Sağlık ve düzeni sordun. Buna altıncı evden, Merkür’den (zihinsel işleyişin) ve Ay’dan ' +
             '(bedeninin duygusal ritmi) bakılır.',
      evGiris: 'Altıncı ev; gündelik rutinin, iş düzenin ve bedeninle kurduğun ilişki. Bu evin burcu, ' +
               'düzen kurma tarzını ve nerede zorlandığını gösterir.',
      element: {
        'Ateş':   'Ateş burcunda: hızlı başlar, çabuk sıkılırsın. Kısa ve yoğun düzenler sana daha çok yarar.',
        'Toprak': 'Toprak burcunda: düzen kurmak doğal yeteneğin. Dikkat: aşırı katılık ve kendini fazla zorlama.',
        'Hava':   'Hava burcunda: düzeni zihinde kurarsın ama uygulamada dağılabilirsin. Yazılı liste sana çok yarar.',
        'Su':     'Su burcunda: bedenin duygularına çok bağlı. Stresli dönemlerde ilk bedenin haber verir.'
      },
      bosEv: 'Altıncı evinde gezegen yok — sağlık ve rutin senin için sürekli bir mesele değil; ' +
             'evin yöneticisinin durumu belirleyici olur.'
    }
  };

  /* Güç cevabına göre haritada karşılığı */
  var GUC_METIN = {
    sezgi:  { g: 'ay',      m: 'Sezgine güvendiğini söyledin. Haritanda bunu Ay taşıyor.' },
    mantik: { g: 'merkur',  m: 'Mantığına güvendiğini söyledin. Haritanda bunu Merkür taşıyor.' },
    irade:  { g: 'mars',    m: 'Kararlılığına güvendiğini söyledin. Haritanda bunu Mars taşıyor.' },
    kalp:   { g: 'venus',   m: 'Şefkatine güvendiğini söyledin. Haritanda bunu Venüs taşıyor.' }
  };

  /* Zorluk cevabına göre haritadaki muhatap + pratik öneri */
  var ZORLUK_METIN = {
    karar: { g: 'merkur',
      m: 'Karar vermekte zorlandığını söyledin. Bu, Merkür’ün seçenekleri fazla açık tutmasıyla ilgili olabilir.',
      oneri: 'Küçük kararları süreye bağla: “bu konuya on dakika, sonra seçiyorum.” Karar kasını böyle çalıştırırsın.' },
    sinir: { g: 'mars',
      m: '“Hayır” diyememek Mars’ın alanına girer — Mars senin sınır çizme ve kendini savunma gücündür.',
      oneri: 'Bu hafta küçük ve gerçek bir “hayır” söyle. Açıklama ekleme; tek cümle yeter.' },
    zihin: { g: 'merkur',
      m: 'Aşırı düşünmek Merkür’ün yorulmadan çalışmasıdır — güçlü bir zihnin gölge tarafı.',
      oneri: 'Zihni boşaltmak için yaz. Kâğıda dökülen düşünce dönmeyi bırakır.' },
    duygu: { g: 'ay',
      m: 'Duyguları taşımak Ay’ın alanıdır. Ay’ın burcu, duygunun sende hangi hızda aktığını söyler.',
      oneri: 'Duyguyu bastırmak yerine adını koy. “Şu an kaygılıyım” demek, onun şiddetini düşürür.' }
  };

  /* Niyet cevabına göre kapanış */
  var NIYET_METIN = {
    tanima: 'Kendini tanımak istediğini söylemiştin. Haritanı bir kimlik kartı gibi değil, bir eğilim ' +
            'haritası gibi oku: burada yazan hiçbir şey kader değil, hepsi hammadde.',
    yon:    'Yönünü netleştirmek istediğini söylemiştin. Yukarıdaki ev ve yönetici okuması tam olarak buna bakar — ' +
            'kararını verirken oradaki burcun tavrını hatırla.',
    tas:    'Sana iyi gelecek taşı aradığını söylemiştin; aşağıdaki öneriler doğrudan bu alanın burcundan ' +
            've haritandaki eksik elementten çıkarıldı.',
    merak:  'Merakla baktığını söylemiştin — en sağlıklısı da bu. Buradaki hiçbir cümleyi kendine dar bir ' +
            'elbise gibi giydirme; tutanı al, tutmayanı bırak.'
  };


  /* ---------------------------------------------------------- DERİN KATMAN
     "Meraklı derine insin, sıradan kullanıcı boğulmasın" — bu veriler
     yalnızca açılır bölümlerde gösterilir. */

  /* Klasik ONUR (essential dignity) tabloları — burç numaraları 0=Koç .. 11=Balık */
  var ONUR = {
    gunes:   { ev:[4],     yuc:[0],  zarar:[10],   dusus:[6] },
    ay:      { ev:[3],     yuc:[1],  zarar:[9],    dusus:[7] },
    merkur:  { ev:[2,5],   yuc:[5],  zarar:[8,11], dusus:[11] },
    venus:   { ev:[1,6],   yuc:[11], zarar:[7,0],  dusus:[5] },
    mars:    { ev:[0,7],   yuc:[9],  zarar:[6,1],  dusus:[3] },
    jupiter: { ev:[8,11],  yuc:[3],  zarar:[2,5],  dusus:[9] },
    saturn:  { ev:[9,10],  yuc:[6],  zarar:[3,4],  dusus:[0] }
  };
  var ONUR_METIN = {
    ev:    { ad:'Kendi burcunda', m:'Bu gezegen kendi evinde — yani en rahat, en doğal hâlinde. ' +
                                     'Bu işlev sende zorlanmadan çalışır; başkasının çaba harcadığı yerde sen akarsın.' },
    yuc:   { ad:'Yücelmede',      m:'Bu gezegen yücelme burcunda — klasik astrolojide en güçlü ikinci konum. ' +
                                     'Bu alan senin doğal üstünlüğün sayılır; fark etmesen de çevren fark eder.' },
    zarar: { ad:'Zararda',        m:'Bu gezegen kendi burcunun karşısında. Bu bir kusur değil, farklı bir yol demek: ' +
                                     'bu işlevi klasik yoldan değil, kendi icat ettiğin yoldan kullanırsın.' },
    dusus: { ad:'Düşüşte',        m:'Bu gezegen düşüş burcunda. Geleneksel yorum “zayıf” der; modern yorum ise ' +
                                     '“en çok emek verdiğin ve bu yüzden en çok ustalaştığın alan” der — ikincisi daha adil.' },
    yok:   { ad:'Nötr',           m:'Bu gezegen ne özel güçte ne zorda — dengeli bir konumda. Etkisi, bulunduğu ' +
                                     'burcun ve evin renginden gelir.' }
  };

  /* Gezegenin haritada YÖNETTİĞİ evler (klasik yöneticilik) — derinlik için */
  function yonettigiEvler(gezKey, yukselenBurcNo, YONETICI) {
    var liste = [];
    for (var ev = 1; ev <= 12; ev++) {
      var burcNo = (yukselenBurcNo + ev - 1) % 12;
      if (YONETICI[burcNo] === gezKey) liste.push(ev);
    }
    return liste;
  }

  /* Gezegenin gündelik hayatta nasıl görüneceği — somut karşılık */
  var GUNLUK = {
    gunes:   'Kendini en çok hangi işi yaparken “ben buyum” diye hissettiğine bak — Güneş’in orada çalışıyor.',
    ay:      'Yorgun ya da üzgünken kendini nereye attığına bak — Ay’ının ihtiyacı orada saklı.',
    merkur:  'Bir konuyu öğrenirken önce ne yaptığına bak (okumak mı, konuşmak mı, denemek mi) — Merkür’ün tarzı odur.',
    venus:   'Sevdiğini nasıl belli ettiğine bak: söz mü, dokunuş mu, emek mi, hediye mi — Venüs’ün dili odur.',
    mars:    'Bir engelle karşılaşınca ilk tepkine bak: üstüne mi gidersin, beklersin mi, dolanır mısın — Mars’ın odur.',
    jupiter: 'Kendini en cömert ve en iyimser hissettiğin alana bak — Jüpiter’in genişlettiği yer orasıdır.',
    saturn:  'Hayatında “kolay olmadı ama öğrendim” dediğin alana bak — Satürn’ün dersi oradaydı.'
  };

  /* Açı derinliği */
  var ACI_DERIN = {
    'Kavuşum':   'İki gezegen aynı noktada. Ayrı ayrı değil, tek bir güç gibi davranırlar — birini kullandığında diğeri de devreye girer.',
    'Karşıt':    'Tam karşı karşıya. Genelde biri içeride biri dışarıda yaşanır; olgunluk, ikisini aynı anda taşıyabilmektir.',
    'Üçgen':     'Aynı elementten iki gezegen. Doğuştan gelen kolaylık; tam da kolay olduğu için fark edilmez ve kullanılmadan kalabilir.',
    'Kare':      'Birbirini iten iki güç. En çok gelişim buradan çıkar — rahatsızlık, hareket ettiren şeydir.',
    'Altmışlık': 'Yumuşak bir iş birliği. Kendiliğinden çalışmaz; fark edip niyet ettiğinde açılan bir kapı gibidir.'
  };
  function aciSiki(sapma) {
    return sapma < 1 ? 'neredeyse tam (çok güçlü)'
         : sapma < 3 ? 'dar (güçlü)'
         : sapma < 5 ? 'orta' : 'geniş (yumuşak)';
  }

  g.ODTIcerik = {
    BURC: BURC, GEZEGEN: GEZEGEN, EV: EV, ELEMENT: ELEMENT,
    NITELIK: NITELIK, ACI: ACI, SORULAR: SORULAR,
    ODAK_EV: ODAK_EV, ODAK_METIN: ODAK_METIN, HAL_METIN: HAL_METIN,
    ALAN: ALAN, YONETICI: YONETICI, GUC_METIN: GUC_METIN,
    ZORLUK_METIN: ZORLUK_METIN, NIYET_METIN: NIYET_METIN,
    ONUR: ONUR, ONUR_METIN: ONUR_METIN, GUNLUK: GUNLUK,
    ACI_DERIN: ACI_DERIN, aciSiki: aciSiki, yonettigiEvler: yonettigiEvler
  };
})(typeof window !== 'undefined' ? window : globalThis);
